/**
 * English (GBP) tag-focused transaction feed for the tags use case.
 */

/** @type {Array<import('../../mock-tagged-transactions.js').MockTaggedTransaction>} */
export const MOCK_TAGGED_TRANSACTIONS_EN = [
	{
		id: 'tag-1',
		date: '2026-08-02',
		type: 'Purchase',
		amount: 48,
		description: 'Business lunch',
		accountId: 'acc-credit',
		accountName: 'Rewards Card',
		currency: 'GBP',
		currencySymbol: '\u00A3',
		currencyDecimalPlaces: 2,
		tagNames: 'Business, Tax',
	},
	{
		id: 'tag-2',
		date: '2026-08-01',
		type: 'Deposit',
		amount: 2400,
		description: 'Salary',
		accountId: 'acc-checking',
		accountName: 'Royal Bank',
		currency: 'GBP',
		currencySymbol: '\u00A3',
		currencyDecimalPlaces: 2,
		tagNames: 'Income',
	},
	{
		id: 'tag-3',
		date: '2026-07-29',
		type: 'Withdrawal',
		amount: 1100,
		description: 'Rent',
		accountId: 'acc-checking',
		accountName: 'Royal Bank',
		currency: 'GBP',
		currencySymbol: '\u00A3',
		currencyDecimalPlaces: 2,
		tagNames: 'Bills',
	},
	{
		id: 'tag-4',
		date: '2026-07-25',
		type: 'Purchase',
		amount: 125,
		description: 'Business books',
		accountId: 'acc-credit',
		accountName: 'Rewards Card',
		currency: 'GBP',
		currencySymbol: '\u00A3',
		currencyDecimalPlaces: 2,
		tagNames: 'Business, Tax',
	},
	{
		id: 'tag-5',
		date: '2026-07-20',
		type: 'Purchase',
		amount: 220,
		description: 'Software subscription',
		accountId: 'acc-credit',
		accountName: 'Rewards Card',
		currency: 'GBP',
		currencySymbol: '\u00A3',
		currencyDecimalPlaces: 2,
		tagNames: 'Business, Tax',
	},
	{
		id: 'tag-6',
		date: '2026-07-18',
		type: 'Purchase',
		amount: 32,
		description: 'Supermarket',
		accountId: 'acc-credit',
		accountName: 'Rewards Card',
		currency: 'GBP',
		currencySymbol: '\u00A3',
		currencyDecimalPlaces: 2,
		tagNames: 'Food',
	},
];
